import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'careers-at-bravissimo/vacancies/:vacancy/more-info/',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/VacancyMoreInfoContainer'),
  }),
};
